import { useEffect, useRef, useState } from "react";
import { FormInputHandle, GenericPopoverFormType } from "../utils/Types";
import { Box, Button, ButtonGroup, Grid, Popover, ThemeProvider, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import { DataFieldInput } from "./DataForm";
import { boxInputStyle, buttonTheme } from "../utils/Common";

function GenericPopoverForm<T>(props: GenericPopoverFormType) {
    const {
        title,
        data,
        fields,
        apiCaller,
        customFormCommands,
        anchorEl,
    } = props;

    const [currentFocusedField, setCurrentFocusedField] = useState<string | null>(fields[0]?.name ?? null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const formRef = useRef<FormInputHandle<T>>({
        getData: () => data,
        validationResult: false,
    });
    const canSaveRef = useRef<boolean>(false);
    
    useEffect(() => {
        const interval = setInterval(() => {
            if (canSaveRef.current === (formRef.current?.validationResult ?? false))
                return;

            canSaveRef.current = formRef.current?.validationResult ?? false;
            setCurrentFocusedField(formRef.current?.currentFocusedField ?? null);
        }, 250);
      
        return () => clearInterval(interval);
    }, []);

    // useEffect(() => console.log({canSave}), [canSave]);

    return (
        <Popover
            open={true}
            aria-labelledby="draggable-dialog-title"
            componentsProps={{
                backdrop: {
                    sx: {
                        pointerEvents: 'none',
                        overflow: 'hidden',
                    }
                }
            }}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            slotProps={{
                paper: {
                    sx: {
                        overflow: 'hidden',
                        pointerEvents: 'auto',
                    },
                },
            }}
            sx={{
                pointerEvents: 'none',
            }}
        >
            <Box
                sx={{
                    overflowY: 'auto',
                    p: "1rem",
                    width: isMobile ? "80vw" : "20vw",
                }}
            >
                <Typography variant="h6" gutterBottom>
                {
                    title
                }
                </Typography>
                <ThemeProvider theme={buttonTheme}>
                    <ButtonGroup
                        sx={{
                            marginBottom: customFormCommands?.length ? "0.5rem" : "0",
                        }}
                    >
                    {
                        customFormCommands?.map((c, idx) => {
                            return (
                                <Tooltip
                                    key={`modal_custom_command_${idx}`}
                                    title={c.title}
                                    arrow
                                >
                                    <Button
                                        variant="contained"
                                        onClick={() => c.action(formRef.current?.getData())}
                                        color={c.color ?? "dark"}
                                        sx={{marginLeft: `${idx ? "2px" : "0"} !important`}}
                                    >
                                    {
                                        <c.icon fontSize="small"/>
                                    }
                                    </Button>
                                </Tooltip>
                            );
                        })
                    }
                    </ButtonGroup>
                </ThemeProvider>
                <Box sx={{...boxInputStyle}}>
                    <Grid container spacing={2}>
                        <DataFieldInput
                            id="generic_modal"
                            fields={fields}
                            apiCaller={apiCaller}
                            data={formRef?.current?.getData() ?? data}
                            ref={formRef}
                            defaultFocusedField={currentFocusedField}
                        />
                    </Grid>
                </Box>
            </Box>
        </Popover>
    );
}

export default GenericPopoverForm;
